import { createApi } from '@reduxjs/toolkit/query/react'
import queryString from 'query-string';
import { IMark, IModel } from '../../types'
import axiosBaseQuery from './API'

interface IMarkData {
  delete: any,
  result:IMark[],
  count:number
}
interface IModelData {
  delete: any,
  result:IModel[],
  count:number
}
// Define a service using a base URL and expected endpoints
export const dashImagesApi = createApi({
  reducerPath: 'dashImagesApi',
  tagTypes: ['DashImagesApi'],
  baseQuery: axiosBaseQuery({ baseUrl: process.env.REACT_APP_API_KEY }),
  endpoints: (builder) => ({
    getDashImages: builder.query<any, {}>({
      query: (data:any) => {
        const stringified = queryString.stringify(data);
        return  {url:`upload/dashImages/?${stringified}`, method:'GET'}
      },
      providesTags: [{ type: 'DashImagesApi' }],
    }),
    addDashImages: builder.mutation<any, Partial<any>>({
      query(body) {        
        return {
          url: `upload/single`,
          method: 'POST',
          data:body,
        }
      },
      invalidatesTags: [{ type: 'DashImagesApi'}],
    }),  
    deleteDashImages: builder.mutation<any, {id:number | null}>({
      query({id}) {        
        return {
          url: `upload/${id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: [{ type: 'DashImagesApi'}],
    }), 
  }),
  
})


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDashImagesQuery, useDeleteDashImagesMutation, useAddDashImagesMutation } = dashImagesApi
